import { useEffect, useState } from "react";
import Pagination from "../../../../components/Pagination";
import api from "../../../../api/api";
import * as bootstrap from "bootstrap";
import "../../Common/form.css";
import Button from "../../../../components/Button";
import InputField from "../../../../components/InputField";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import Table from "../../../../components/table";
import usePagination from "../../../../utils/usePagination";

const UserMaster = () => {
  const [usermasters, setUsermasters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedUser, setSelectedUser] = useState(null);
  const [modalType, setModalType] = useState(null);
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(usermasters, 5);

  useEffect(() => {
    const fetchUsermasters = async () => {
      setLoading(true);
      try {
        const response = await api.get("/master-data/user-master");
        console.log("API response:", response.data.users);
        setUsermasters(response.data.users || []);
      } catch (error) {
        setError("Failed to fetch usermaster");
        console.error("Failed to fetch usermaster", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsermasters();
  }, []);
  const handleSaveChanges = async () => {
    try {
      if (!selectedUser || !selectedUser.user_id) {
        return;
      }
      console.log("Saving user:", selectedUser);
      console.log("User ID type:", typeof selectedUser.user_id);

      const response = await api.put(
        `/master-data/user-master/${selectedUser.user_id}`,
        {
          phone_number: selectedUser.phone_number,
        }
      );

      setUsermasters((prev) =>
        prev.map((user) =>
          user.user_id === selectedUser.user_id ? selectedUser : user
        )
      );

      handleCloseModal();
    } catch (err) {
      console.error("Error updating User:", err);
    }
  };
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, [usermasters, currentPage]);

  const handleOpenModal = (user, type) => {
    setSelectedUser(user);
    setModalType(type);
  };

  const handleCloseModal = () => {
    setSelectedUser(null);
    setModalType(null);
  };

  const handleConfirmDelete = async () => {
    try {
      await api.delete(`/master-data/user-master/${selectedUser.user_id}`);
      setUsermasters((prev) =>
        prev.filter((u) => u.user_id !== selectedUser.user_id)
      );
      handleCloseModal();
    } catch (err) {
      console.error("Failed to delete user", err);
    }
  };

  const columns = [
    { label: "User ID", accessor: "user_id" },
    { label: "Name", accessor: "full_name" },
    { label: "Phone Number", accessor: "phone_number" },
    { label: "Email", accessor: "email" },
    { label: "Company", accessor: "company_name" },
    { label: "Role", accessor: "user_role" },
    {
      label: "Action",
      render: (row) => (
        <>
          <EditIcon
            onClick={() => handleOpenModal(row, "edit")}
            style={{ cursor: "pointer", color: "#1e305e" }}
          />
          <DeleteIcon
            onClick={() => handleOpenModal(row, "delete")}
            style={{ cursor: "pointer", color: "#1e305e" }}
          />
        </>
      ),
    },
  ];

  if (error) return <p className="text-danger">{error}</p>;

  return (
    <>
      <Breadcrumbs />
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No exchange rates found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
      {selectedUser && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {modalType === "edit" ? "Edit User" : "Confirm Delete"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>

              <div className="modal-body">
                {modalType === "edit" ? (
                  <form>
                    {console.log(
                      "Selected User in Modal:",
                      selectedUser.phone_number
                    )}
                    <p className="mb-3">Full Name : {selectedUser.full_name}</p>
                    <p className="mb-3">Email : {selectedUser.email}</p>
                    <div className="mb-3">
                      <label className="form-label">Phone Number :</label>
                      <InputField
                        value={selectedUser.phone_number}
                        type="text"
                        onChange={(e) => {
                          let val = e.target.value;
                          val = val.replace(/(?!^\+)\D/g, "");
                          setSelectedUser({
                            ...selectedUser,
                            phone_number: val,
                          });
                        }}
                      />
                    </div>
                  </form>
                ) : (
                  <div className="text-center">
                    <p>Are you sure you want to delete this user?</p>
                    {/* <p className="text-danger mb-0">
                      {selectedUser.full_name} ({selectedUser.email})
                    </p> */}
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>

                {modalType === "delete" ? (
                  <Button
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                    text="Confirm"
                  />
                ) : (
                  <Button
                    className="btn btn-primary"
                    onClick={handleSaveChanges}
                    text="Submit"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserMaster;